import { Formik } from 'formik'
import React, { useState, useEffect } from 'react'
import { MdSlideshow, MdAddCircle } from 'react-icons/md'
import { Table, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import { AiFillEdit, AiFillDelete, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'

import BtnLoader                from '../buttons/loader/index.js'
import ControlWithValidation    from '../fields/controlWithValidation/index.js'
import SelectWithValidation     from '../fields/selectWithValidation/index.js'
import ControlWithValidationInfo from '../fields/controlWithValidationInfo/index.js'

// schema validation
import * as schema                  from '../schemaValidation/index.js'

import './styles.css'
import BtnSave from '../buttons/save/index.js'

// define a tabela com os campos do arquivo
const IntegrationLayerTableFields = ({
    fields,
    setFields,
    readOnly,
    setAlert,
    setShowAlert
}) => {
    const field_empty = {
        id: '',
        name_field: '',
        datalake_field_name: '',
        data_type: '',
        des_field: '',
        mask_field: '',
        status: false
    }

    const [tableHidden, setTableHidden] = useState("mf-register-hidden");
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tooltip, setTooltip] = useState('');
    const [field, setField] = useState(field_empty)

    // if table has fields then show the table 
    useEffect(() => {
        if (fields.length > 0) setTableHidden("")
    }, [fields])

    // salva a linha para que possa ser usado na edição
    const onEditField = (data) => {
        handleShow()
        handleSaveField(data)
    }

    // deleta a linha selecionada da tabela
    const onDeleteField = (row) => {
        if (window.confirm("Deseja remove esse campo?")) {
            const temp  = fields
                            .filter(item => item.id !== row.id)
                            .map((item, index) => ({...item, id: index}))

            handleSaveFields(temp)
        }
    }

    // salva a linha na tabela
    const onSaveField = (data) => {
        setLoading(true)
        var rowsEdit = fields
        data.status = true

        const numRows =  rowsEdit.filter(x => x.id === data.id).length

        if(numRows > 0) {
            rowsEdit = rowsEdit.map((item, index) => (
                (item.id === data.id) ? data : item
            ))
        } else {
            rowsEdit.push(data)
        }

        setLoading(false)
        handleSaveFields(rowsEdit)
        handleClose()
        setTableHidden('')
    }

    // adiciona uma nova linha a tabela
    const handleAddRow = () => {
        handleSaveField({...field_empty, id: fields.length})
        handleShow()
    }

    // handle show or close edit/add field
    const handleClose = () => setShow(false);
    const handleShow  = () => setShow(true);

    // edit fields
    const handleSaveFields = (value) => setFields(value);

    // edit field
    const handleSaveField = (value) => setField(value);

    return (
        <div>
            <UpdateOrCreateField
                handleClose={handleClose} 
                show={show}
                field={field}
                onSaveField={onSaveField}
                fieldSchema={schema.fieldIntegrationLayerSchema}
                readOnly={readOnly}
                loading={loading}
                handleAddRow={handleAddRow}
                tooltip={tooltip}
                setTooltip={setTooltip}
            />

            <TableCustom
                handleAddRow={handleAddRow} 
                tableHidden={tableHidden}
                fields={fields}
                setFields={setFields}
                onEditField={onEditField}
                onDeleteField={onDeleteField}
                readOnly={readOnly} />
        </div>
    )
}


// define um campo da tabela de campos do arquivo
const UpdateOrCreateField = ({ 
    field, 
    onSaveField, 
    fieldSchema, 
    handleClose, 
    show,
    readOnly=false,
    loading,
    handleAddRow,
    tooltip,
    setTooltip
}) => (
    <div>
        {!readOnly ?
            <div className="mf-register-container-btn">
                <Button className='btn-next btn-icon-text' variant="secondary" onClick={handleAddRow}>
                    <MdAddCircle size={20} className='btn-icon' />
                    Campo
                </Button>
            </div>
        : null}
   
        <Modal
            dialogClassName="tf-main-modal"
            show={show}
            onHide={handleClose}
            animation={true}
            centered >
            <Modal.Header closeButton>
                <Modal.Title>Editando campo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        id: field.id, 
                        name_field: field.name_field,
                        datalake_field_name: field.datalake_field_name, 
                        data_type: field.data_type,
                        des_field: field.des_field,
                        mask_field: field.mask_field
                    }}
                    validationSchema={fieldSchema}
                    onSubmit={(values) => onSaveField(values)}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit} id="fooId">
                        <RowsField 
                            values={values}
                            errors={errors}
                            handleChange={handleChange}
                            readOnly={readOnly}
                            tooltip={tooltip}
                            setTooltip={setTooltip}
                        />

                        <div className="mf-register-fields-container-btn">
                            <BtnLoader
                                loading={loading}
                                messageNotLoading="Salvar"
                                messageLoading="Salvando"
                                style={"btn-loader-135px"}
                                variant={"success"}
                            />
                        </div>
                    </Form>
                )}
                </Formik>
            </Modal.Body>
        </Modal>
    </div>
)

const RowsField = ({ 
    values,
    errors,
    handleChange,
    readOnly=false,
    tooltip,
    setTooltip
}) => {
    
    if (values.data_type === 'integer') {
        setTooltip(
            "Use # para representar um caractere númerico. Para separador decimal/milhar use ponto ou vírgula. Exemplos.: #,### | #.### | # ..."
        )
    } else if (values.data_type === 'float') {
        setTooltip(
            "Use # para representar um caractere númerico. Para separador decimal/milhar use ponto ou vírgula. Exemplos.: #,###.# | #.###,# | #,# | #.# ..."
        )
    } else if (values.data_type === 'boolean') {
        setTooltip(
            'Separe os dois estados possíveis por "|". Exemplos.: V|F ou Verdadeiro|Falso ou S|N ou Sim|Não ou True|False ...'
        )
    } else if (values.data_type === 'date') {
        setTooltip(
            '30/04/2022 => dd/mm/yyyy. Considere o seguinte padrão: yyyy=2022 (ano 4 digitos) ou yy=22 (ano 2 digitos); mm=04 (mês 2 digitos) ou mmm=Abr (Nome do mês abreviado) ou mmmm=April (Nome do mês completo); d=6 (dia da semana) ou dd=30 (dia do mês) ou ddd=Sat (Nome do dia da semana abreviado) ou dddd=Saturday (Nome do dia da semana completo)'
        )
    } else if (values.data_type === 'datetime') {
        setTooltip(
            '30/04/2022T10:33:59.201222 => dd/mm/yyyyTH:M:S.f Considere o seguinte padrão: yyyy=2022 (ano 4 digitos) ou yy=22 (ano 2 digitos); mm=04 (mês 2 digitos) ou mmm=Abr (Nome do mês abreviado) ou mmmm=April (Nome do mês completo); d=6 (dia da semana) ou dd=30 (dia do mês) ou ddd=Sat (Nome do dia da semana abreviado) ou dddd=Saturday (Nome do dia da semana completo), adicionalmente: H=10 (Horas); M=33 (Minutos); S=59 (Segundos) e por fim f=201222 (microsegundos c/ 6 digitos)'
        )
    }

    return (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="ID"
                name="id"
                placeholder=""
                value={values.id}
                error={errors.id}
                handleChange={handleChange}
                typeColumn="xs"
                valueColumn={1}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="Nome do campo na origem"
                name="name_field"
                placeholder=""
                value={values.name_field}
                error={errors.name_field}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="Nome do campo no datalake"
                name="datalake_field_name"
                placeholder=""
                value={values.datalake_field_name}
                error={errors.datalake_field_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation
                key="data_type"
                Col={Col}
                type="text"
                label="Tipo do dado"
                name="data_type"
                placeholder=""
                value={values.data_type}
                error={errors.data_type}
                handleChange={handleChange}
                options={["", "string", "integer", "float", "boolean", "date", "datetime"]}
                typeColumn="xs"
                valueColumn={2}
                readOnly={readOnly}
            />

        </Row>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="Descrição do campo"
                name="des_field"
                placeholder=""
                value={values.des_field}
                error={errors.des_field}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            {["integer", "float", "boolean", "date", "datetime"].includes(values.data_type) ?
                <ControlWithValidationInfo Col={Col}
                    type="text"
                    label="Máscara do campo"
                    name="mask_field"
                    placeholder=""
                    value={values.mask_field}
                    error={errors.mask_field}
                    handleChange={handleChange}
                    readOnly={readOnly}
                    tooltip={tooltip}
                />
            :
                <ControlWithValidation Col={Col}
                    type="text"
                    label="Máscara do campo"
                    name="mask_field"
                    placeholder=""
                    value={values.mask_field}
                    error={errors.mask_field}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />
            }
        </Row>
    </div>
    )
}


const onCheckFields = (fields, setFields) => {

    const fieldsCustom = fields.map((field, index) => {
        field.status = false;

        if (
            field.name_field.replaceAll(' ','').length === 0 |
            field.data_type.replaceAll(' ','').length === 0 |
            field.des_field.replaceAll(' ','').length === 0
        ) {
            field.status = false
        } else if (field.data_type === 'string') {
            field.status = true
        } else if (field.data_type === 'integer' & field.mask_field.length > 0) {
            field.status = true
        } else if (field.data_type === 'float' & field.mask_field.length > 0) {
            field.status = true
        } else if (field.data_type === 'boolean' & field.mask_field.length > 0) {
            field.status = true
        } else if (field.data_type === 'date' & field.mask_field.length > 0) {
            field.status = true
        } else if (field.data_type === 'datetime' & field.mask_field.length > 0) {
            field.status = true
        }

        return field
    })
}

const TableCustom = ({ 
    handleAddRow, 
    tableHidden, 
    fields,
    setFields,
    onEditField, 
    onDeleteField,
    readOnly=false
}) => {
    const columns = [
        '#', 
        'Nome do campo na origem',
        'Nome do campo no datalake',
        'Tipo do dado', 
        'Descrição', 
        'Mascara dos campos', 
        'Status', 
        'Ações'
    ]

    onCheckFields(fields, setFields)

    return (
        <div>
            <Table striped bordered hover className={tableHidden}>
                <thead>
                    <tr>
                        {columns.map((item, index) => (
                            <th>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {fields.map((row, index) => (
                        <tr>
                            <td>{row.id}</td>
                            <td>{row.name_field}</td>
                            <td>{row.datalake_field_name}</td>
                            <td>{row.data_type}</td>
                            <td>{row.des_field}</td>
                            <td>{row.mask_field}</td>
                            <td>{row.status ?
                                <AiOutlineCheck size={20} className="mf-register-ok-status" /> 
                            :
                                <AiOutlineClose size={20} className="mf-register-nok-status" />}
                            </td>
                            {!readOnly ?
                                <td className="mf-register-actions">
                                    <AiFillEdit size={20} className="mf-register-edit" onClick={() => onEditField(row)} />
                                    <AiFillDelete size={20} className="mf-register-delete" onClick={() => onDeleteField(row)} />
                                </td>
                                :
                                <td  className="mf-register-actions">
                                    <MdSlideshow size={20} className="mf-register-edit" onClick={() => onEditField(row)} />    
                                </td>}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default IntegrationLayerTableFields;
